<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新增管理</el-breadcrumb-item>
        <el-breadcrumb-item>采购管理</el-breadcrumb-item>
        <el-breadcrumb-item>采购看板</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 头部用户人数显示 -->
    <el-row :gutter="24">
      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <p class="user">本月采购支出总额</p>
            <p class="number">{{CaiGouTotalPayMonth}}</p>
          </div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <el-card class="box-card">
          <div class="userList">
            <p class="user">本年采购支出总额</p>
            <p class="number">{{CaiGouTotalPayYear}}</p>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">本年采购金额---柱状图</div>
          <ve-histogram :data="CaiGouYearList" :extend="trainingExtend" :legend-visible="false" :colors="trainingColors"></ve-histogram>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">本年物料采购金额占比---饼状图</div>
          <ve-pie :data="CaiGouProjectList" :legend-visible="true"></ve-pie>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">本年采购金额---列表</div>
          <!-- 数据列表 start -->
          <el-table :data="CaiGouYearListRows" ref="CaiGouYearListRows" :cell-style="{padding: '0'}" border height="360">
            <el-table-column prop="Month" label="月份" min-width="25%"></el-table-column>
            <el-table-column prop="Moneys" label="金额" min-width="25%"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">本年物料采购金额占比---列表</div>
          <!-- 数据列表 start -->
          <el-table :data="CaiGouProjectListRows" ref="CaiGouProjectListRows" :cell-style="{padding: '0'}" border height="360">
            <el-table-column prop="Name" label="名称" min-width="25%"></el-table-column>
            <el-table-column prop="Moneys" label="金额" min-width="25%"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="24">
        <el-card class="box-card">
          <div class="card_title">本月主要物料采购明细---列表</div>
          <!-- 数据列表 start -->
          <el-table :data="PurchaseDetailsList" ref="PurchaseDetailsList" :row-class-name="tableRowClassName" :span-method="mergeSameRows" :cell-style="{padding: '0'}" border height="360">
            <el-table-column prop="ProjectName" label="采购项目名称" width="250"></el-table-column>
            <el-table-column prop="MaterialName" label="物料名称" width="200"></el-table-column>
            <el-table-column prop="TotalCaiGouNums" label="采购数量（套）" width="130"></el-table-column>
            <el-table-column prop="TotalCaiGouDanJias" label="平均采购单价" width="120"></el-table-column>
            <el-table-column prop="TotalCaiGouJinEs" label="合同金额" width="100"></el-table-column>
            <el-table-column prop="TotalYesJinEs" label="已付金额" width="100"></el-table-column>
            <el-table-column prop="TotalNoJinEs" label="未付金额" width="100"></el-table-column>
          </el-table>
          <!-- 数据列表 end -->
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyErp6PurchaseOrderSignboard',
  data () {
    // 训练数据反馈表
    this.trainingExtend = {
      series (v) {
        v.forEach(i => {
          i.barWidth = 20
        })
        return v
      }
    }
    return {
      CaiGouTotalPayMonth: 0,
      CaiGouTotalPayYear: 0,
      CaiGouYearList: {
        columns: ['Month', 'Moneys'],
        rows: []
      },
      CaiGouYearListRows:[],
      CaiGouProjectList: {
        columns: ['Name', 'Moneys'],
        rows: []
      },
      CaiGouProjectListRows:[],
      PurchaseDetailsList: [],
      trainingColors: ['#4ad2ff']
    }
  },
  mounted () {
    this.apiErp6PurchaseOrderSignboard()
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if(row.MaterialName == '小计'){
        return 'success-row';
      }
      return '';
    },
    mergeSameRows({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex === 0) {
      //   if(row.LenHeBing > 0){
      //     return [row.LenHeBing, 1];
      //   } else {
      //     return [0,0];
      //   }
      // }
    },
    apiErp6PurchaseOrderSignboard: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Erp6PurchaseOrderSignboard, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.CaiGouTotalPayMonth = response.data.CaiGouTotalPayMonth
          that.CaiGouTotalPayYear = response.data.CaiGouTotalPayYear
          that.CaiGouYearList.rows = response.data.CaiGouYearList
          that.CaiGouYearListRows = response.data.CaiGouYearList
          that.CaiGouProjectList.rows = response.data.CaiGouProjectList
          that.CaiGouProjectListRows = response.data.CaiGouProjectList
          that.PurchaseDetailsList = response.data.PurchaseDetailsList
          console.log(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

</style>

<style lang="less" scoped>
.box-card{
    margin-top: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.userList{
    display: flex;
    align-items: center;
    .user{
        color:#999;
        margin: 0 20px 0 0;
    }
    .number{
        font-size: 30px;
        margin: 0;
        font-weight: bold;
    }
}

.warntitle{
    //display: flex;
    align-items: center;
    color:#ff0000;
    font-size: 30px;
    margin: 0;
    font-weight: bold;
    text-decoration:underline;
    text-align:center;
}

.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}

</style>
